export * from "./Mc2ReadonlyCell";
